import axios from "axios";
import AuthService from "./auth";

/**
 * Standalone Web Promotion — the identity cookie endpoints.
 *
 * See docs/standalone-web-promotion-plan.md §5.
 *
 * IMPORTANT: these deliberately do NOT use REACT_APP_API_URL, and that is not
 * an oversight to tidy up later.
 *
 * The 160-day identity cookie is READ at /go/<slug>, which nginx proxies from
 * the player-facing host (capture.playticket.us). So it has to be WRITTEN on
 * that same origin. Posting these to the API host instead would set the cookie
 * on pt3api.playticket.us, where /go/ can never see it — and the only symptom
 * would be every player asked for their club number on every single visit,
 * with nothing in any log to explain why.
 *
 * Empty origin means a relative URL, which is correct in production where /go/
 * and the app share a host. In development the app runs on :3000 and Django on
 * :8001, so REACT_APP_WEB_ORIGIN points at the backend — cookies ignore the
 * port, so localhost still shares one jar between the two.
 */
const WEB_ORIGIN = process.env.REACT_APP_WEB_ORIGIN || "";

class WebService {
    /**
     * Remember this player on this device for 160 days.
     *
     * playerId is sent because the session was opened before anybody had
     * identified themselves — /go/ starts with no player and only the browser
     * knows who came out of the club-number dialog. The server checks the id
     * against the session's venue before trusting it.
     */
    remember(sessionId, playerId){
        return this._post("/go/remember", sessionId, { player_id: playerId });
    }

    /** Forget them — backs a "Not you?" affordance. */
    forget(sessionId){
        return this._post("/go/forget", sessionId);
    }

    _post(path, sessionId, extra){
        var auth = AuthService.getCurrentAuth();
        var token = auth && auth.access;
        return axios.post(
            WEB_ORIGIN + path,
            Object.assign({ sid: sessionId }, extra || {}),
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                // Required for the browser to accept Set-Cookie when this is a
                // cross-origin call (development only — same-origin in prod).
                withCredentials: true,
            }
        ).then(r => r.data);
    }
}

export default new WebService();
